import request from '@/util/request'

const state = {
  recentSupportCase: {
    netsuite_caseNumber: null,
    title: null,
  },
}

// getters
const getters = {
  getRecentSupportCase: (state) => state.recentSupportCase,
}

// actions
const actions = {
  async submitSupportCase({commit, getters, dispatch}, data) {
    return request({
      url: '/support-cases/create',
      data,
      method: 'post',
    }).then((data) => {
      commit('SET_RECENT_SUPPORT_CASE', data)
    })
  },
  async submitSignup({commit, getters, dispatch}, data) {
    return request({
      url: '/support-cases/sign-up',
      data,
      method: 'post',
    }).then((data) => {
      commit('SET_RECENT_SUPPORT_CASE', data)
    })
  },
}

// mutations
const mutations = {
  SET_RECENT_SUPPORT_CASE(state, data) {
    state.recentSupportCase = data
  },
}

export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations,
}
